// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__XOcsq","submitButton":"LoginForm_submitButton__7hyp3","errorMessage":"LoginForm_errorMessage__8P9zB","passkeyButton":"LoginForm_passkeyButton__ZqWOD"};